var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppointment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9403 15C20.3561 15 20.6933 15.3242 20.6933 15.7241V17.1849C21.3612 17.1724 22.1098 17.1724 22.9522 17.1724H26.9681C27.8104 17.1724 28.5591 17.1724 29.227 17.1849V15.7241C29.227 15.3242 29.5641 15 29.98 15C30.3958 15 30.733 15.3242 30.733 15.7241V17.2489C32.178 17.3602 33.1267 17.6333 33.8236 18.3036C34.5206 18.9738 34.8046 19.8862 34.9203 21.2759L35 22H15.9246H15V21.2759C15.1157 19.8862 15.3997 18.9738 16.0967 18.3036C16.7936 17.6333 17.7423 17.3602 19.1873 17.2489V15.7241C19.1873 15.3242 19.5244 15 19.9403 15Z",
    fill: "#1177BD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0005 27.0001V25.0001C35.0005 24.161 34.9972 22.6653 34.9843 22H15.0101C14.9972 22.6653 15.0005 24.161 15.0005 25.0001V27.0001C15.0005 30.7713 15.0005 32.6569 16.1721 33.8285C17.3436 35.0001 19.2293 35.0001 23.0005 35.0001H27.0005C30.7717 35.0001 32.6574 35.0001 33.8289 33.8285C35.0005 32.6569 35.0005 30.7713 35.0005 27.0001Z",
    fill: "#84DCC8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31 30C31 30.5523 30.5523 31 30 31C29.4477 31 29 30.5523 29 30C29 29.4477 29.4477 29 30 29C30.5523 29 31 29.4477 31 30Z",
    fill: "#1177BD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31 26C31 26.5523 30.5523 27 30 27C29.4477 27 29 26.5523 29 26C29 25.4477 29.4477 25 30 25C30.5523 25 31 25.4477 31 26Z",
    fill: "#1177BD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26 30C26 30.5523 25.5523 31 25 31C24.4477 31 24 30.5523 24 30C24 29.4477 24.4477 29 25 29C25.5523 29 26 29.4477 26 30Z",
    fill: "#1177BD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26 26C26 26.5523 25.5523 27 25 27C24.4477 27 24 26.5523 24 26C24 25.4477 24.4477 25 25 25C25.5523 25 26 25.4477 26 26Z",
    fill: "#1177BD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21 30C21 30.5523 20.5523 31 20 31C19.4477 31 19 30.5523 19 30C19 29.4477 19.4477 29 20 29C20.5523 29 21 29.4477 21 30Z",
    fill: "#1177BD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21 26C21 26.5523 20.5523 27 20 27C19.4477 27 19 26.5523 19 26C19 25.4477 19.4477 25 20 25C20.5523 25 21 25.4477 21 26Z",
    fill: "#1177BD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#ECEDEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointment);
export default __webpack_public_path__ + "static/media/appointment.48f75003afa8c6931a9215027b02514b.svg";
export { ForwardRef as ReactComponent };